<template>
  <el-card>
    <div class="title-biaoti">Hostess Income Detail</div>
    <el-row class="search">
      <el-date-picker v-model="search.date" type="daterange" value-format="yyyy-MM-dd"
        :picker-options="retainedOptions" />
      <el-input style="width:180px" v-model="search.hostessId" placeholder="Please enter hostessId"></el-input>
      <el-button type="primary" @click="query()" :loading="loading">Search</el-button>
    </el-row>
    <el-row>
      <el-table :data="hostData" style="width: 100%" v-loading="loading" height="70vh" stripe border
        element-loading-text="loading" element-loading-spinner="el-icon-loading">
        <el-table-column prop="date" label="Date"></el-table-column>
        <el-table-column prop="rid" label="Hostess ID"></el-table-column>
        <el-table-column prop="totalCallCount" label="Total Call Duration"></el-table-column>
        <el-table-column prop="totalConnectCount" label="Total Connect Count"></el-table-column>
        <el-table-column prop="matchCallCount" label="Match Call Count"></el-table-column>
        <el-table-column prop="avgCallDuration" label="Avg Call Duration"></el-table-column>
        <el-table-column prop="callIncomeUSD" label="Call Income USD"></el-table-column>
        <el-table-column prop="giftIncomeUSD" label="Gift Income USD"></el-table-column>
        <el-table-column prop="taskIncomeUSD" label="Task Income USD"></el-table-column>
        <el-table-column prop="matchTotalIncomeUSD" label="Match Total Income USD"></el-table-column>
        <el-table-column prop="giftRate" label="Gift Rate"></el-table-column>
        <el-table-column prop="matchCallIncomeRate" label="Match Call Income Rate"></el-table-column>
        <el-table-column prop="taskIncomeRate" label="Task Income Rate"></el-table-column>
        <el-table-column prop="totalIncomeUSD" label="Total Income USD"></el-table-column>
      </el-table>
    </el-row>

    <el-row style="overflow: auto">
      <el-pagination @current-change="handleCurrentChangepat" :current-page="page" :page-size="30"
        layout="total,prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import {
  getHostList,
  getCountryList,
  getBindHost,
  getUntieHost
} from '@/api/operate.js'
import { getHostessIncomeDetail } from '@/api/income_detail.js'
import { bootstrapResponsive } from '@/utils/bootstrapResponsive.js'
import { datainfor } from '@/utils/formdata.js'

export default {
  data() {
    return {
      deleteBun: false,
      countryList: [],
      dialogVisible: false,
      hostId: '',
      countryListIndex: '',
      gMail: '',
      // 验证输入内容
      rules: false,
      clientWidth: 'xs',



      loading: false,
      hostessId: '',
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() >= Date.now() - 86400000
        }
      },
      search: {
        date: [datainfor(1), datainfor(1)],
        hostessId: ''
      },
      hostData: [],
      // 分页
      page: 1,
      total: 0,
    }
  },
  created() {
    this.clientWidth = bootstrapResponsive()
    this.query()
  },
  methods: {
    async query() {
      this.loading = true
      const query = {
        start: this.search.date[0],
        end: this.search.date[1],
        page: this.page
      }
      if (this.search.hostessId != '') query.rid = this.search.hostessId
      const { data: res } = await getHostessIncomeDetail({ ...query })
      if (res.code !== 0) return this.$message.error(res.msg)
      this.hostData = res.data.data
      this.total = res.data.total
      this.loading = false
    },

    // 分页
    handleCurrentChangepat(newpage) {
      this.page = newpage
      this.query()
    },

  }
}
</script>

<style lang="scss" scoped>
.agent {
  min-height: 100%;
}

.host-name {
  margin-right: 15px;
}

.newcss {
  /* 这两个在技术上是一样的, 为了兼容了浏览器两个都加上 */
  overflow-wrap: break-word;
  word-wrap: break-word;

  -ms-word-break: break-all;
  /* 这个的使用在web-kit中有些危险，他可能会阶段所有东西 */
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;

  /* 如果浏览器支持的话增加一个连接符(Blink不支持) */
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
}
</style>
